import React, { useEffect, useState } from 'react'
import { getStreamsFromFirestore } from '../apis/firebase'
export default function Streams() {
  const [streams, setStreams] = useState([])
  
  useEffect(() => {
    const loadStreams = async () => {
      const fbStreams = await getStreamsFromFirestore()
      
      if (fbStreams && fbStreams.length > 0) {
        
          setStreams(fbStreams[0].streams)
          console.log(fbStreams[0].streams)
          

        }

    
      }
      
      loadStreams()
      
  }, [])

  return (
    <div className='secondary-blue center'>
        <div className='container'>
          <h1 className='yellowtext'>Upcoming streams</h1>
          {(streams && streams.length > 0) ? (
            <div className='row'>
              {streams.map((stream) => (
                <a href={'https://www.youtube.com/watch?v=' + stream.id} target='_blank' rel='noreferrer'>
                <div className='col m4 s12' key={stream.id.videoId}>
                  <img src={stream.snippet.thumbnails.default.url} alt={stream.snippet.title} width={'100%'}/>
                  <h6 className='yellowtext'>{stream.snippet.title}</h6>
                  <p className='yellowtext'>{new Date(stream.liveStreamingDetails.scheduledStartTime).toLocaleDateString('en-US', {weekday: 'long', day: 'numeric' , hour: 'numeric', minute: '2-digit', timeZoneName: 'short', hourCycle: 'h23'})}</p>
                  
                </div>
                </a>
              ))}

            </div>

          )
          :
          (
            <div>
            <p className='yellowtext infotext'>There are currently no streams scheduled.</p>
            <p className='yellowtext infotext'>But the regular stream schedule is:</p>
            <ul className='yellowtext infotext'>
              <li><strong>Tuesdays & Thursdays 18:00-20:00 CET*</strong></li>
            </ul>
            <p className='yellowtext infotext'>*Not set in stone.</p>
            </div>
          )
          }
          
        </div>
      </div>
      
  )
}
